module.exports = __webpack_public_path__ + "static/media/-_leave.a2230303.png";